import { Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton } from "@mui/material";
import { FaUserCircle } from "react-icons/fa";
import { IoCloseSharp } from "react-icons/io5";
import "./clientDetailsDialog.css";

const detailFields = [
    { key: "nationalCode", label: "کد ملی" },
    { key: "englishName", label: "نام به انگلیسی" },
    { key: "englishLastName", label: "نام خانوادگی به انگلیسی" },
    { key: "birthdate", label: "تاریخ تولد" },
];

export default function ClientDetailsDialog({ client, onClose, theme }) {
    const fullName = `${client?.name || ""} ${client?.lastName || ""}`.trim();

    return (
        <Dialog
            open={Boolean(client)}
            onClose={onClose}
            fullWidth
            maxWidth="sm"
            dir="rtl"
            className={`clientDetailsDialog${theme === "dark" ? " clientDetailsDialog--dark" : ""}`}
            aria-labelledby="client-details-title"
            aria-describedby="client-details-description"
        >
            <DialogTitle component="div" className="clientDetailsTitle">
                <div className="clientDetailsHeading">
                    <FaUserCircle className="clientDetailsHeaderIcon" aria-hidden="true" />
                    <h2 id="client-details-title">اطلاعات تکمیلی کاربر</h2>
                </div>
                <IconButton onClick={onClose} aria-label="بستن پنجره" className="clientDetailsClose">
                    <IoCloseSharp aria-hidden="true" />
                </IconButton>
            </DialogTitle>
            <DialogContent className="clientDetailsContent">
                <p id="client-details-description" className="clientDetailsName">{fullName || "کاربر"}</p>
                <dl className="clientDetailsFields">
                    {detailFields.map(({ key, label }) => {
                        const value = String(client?.[key] ?? "").trim();
                        return (
                            <div className="clientDetailsField" key={key}>
                                <dt>{label}</dt>
                                <dd className={value ? "clientDetailsValue" : "clientDetailsMissing"} dir={value ? "ltr" : "rtl"}>
                                    {value || "تکمیل نشده"}
                                </dd>
                            </div>
                        );
                    })}
                </dl>
            </DialogContent>
            <DialogActions className="clientDetailsActions">
                <Button onClick={onClose} className="clientDetailsDone">بستن</Button>
            </DialogActions>
        </Dialog>
    );
}
